<template>
  <footer class="footer-menu">
    <slot></slot>
  </footer>
</template>
<style scoped>
.footer-menu {
  background: linear-gradient(#524e4d, #71686c);
}
</style>
